<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-anti-violence`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.657 2.826L45.255 42.39a.998.998 0 010 1.413l-1.414 1.413a1 1 0 01-1.415 0L2.83 5.652a.999.999 0 010-1.413l1.414-1.413a1 1 0 011.414 0zm-.7 9.176l2.9 2.88c-.082.185-.128.39-.128.605v2.429l.018.123-.01.195a4.561 4.561 0 00-.008.25v4.496l2.195.194-2.696 14.793h5.976l2.56-14.147.017-.08.182-.82 3.44 3.411-.283 1.565a3.054 3.054 0 001.75-.107l2.964 2.938a7.058 7.058 0 01-4.017 1.245c-.482 0-.954-.048-1.409-.14l-1.387 7.664a3.015 3.015 0 01-2.974 2.468H6.022C4.353 41.964 3 40.622 3 38.966c0-.178.016-.357.048-.533l2.237-12.275A3.982 3.982 0 013.7 22.98v-4.496c0-.105.002-.21.006-.314a2.988 2.988 0 01-.006-.186v-2.497c0-1.323.471-2.536 1.256-3.485zm36.32-2.01V7.992H37.25v1.998H17.172l4.03 3.997H40.97v2.997H30.898v3.997h-2.644l3.846 3.816a4.002 4.002 0 002.827-3.816h7.051c1.67 0 3.022-1.342 3.022-2.997v-4.996c0-1.656-1.353-2.998-3.022-2.998h-.7z"/></svg>
</template>
<script>

export default {
  name: 'IconAntiViolence',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
